<template>
  <svg viewBox="0 0 64 64">
    <svg>
      <svg id="klimaat">
        <path
          d="M59.6,34.7c-0.3,0-0.5-0.1-0.7-0.4l-1.8-2.6c-0.5-0.7-1.2-1-2-1h-1.2c-0.6,0-1.1,0.2-1.6,0.6l-0.7,0.6
                        c-0.1,0.1-0.3,0.2-0.5,0.2h-2.6c-0.2,0-0.4-0.1-0.6-0.2l-6.2-6.2c-0.5-0.5-1.1-0.7-1.7-0.7H33c-0.2,0-0.5-0.1-0.6-0.3
                        c-0.2-0.2-0.2-0.4-0.2-0.6c0.1-1.1,0.5-2.6,1.3-4c1.2-1.9,4.2-1.9,5.5-1.8c0.7,0,1.4-0.2,1.9-0.7l1.7-1.7c0.2-0.2,0.4-0.2,0.6-0.2
                        h5.7c0.6,0,1.3-0.3,1.7-0.7l1.9-2c6,5.1,9.8,12.7,9.8,21.3c0,0.2,0,0.4,0,0.7H59.6z M35.1,4.7c-1.7,0-3.4,0.2-5.1,0.5
                        c-0.4,0.1-0.7,0.5-0.6,1c0.1,0.4,0.5,0.7,0.9,0.7c1.6-0.3,3.2-0.4,4.8-0.4c6,0,11.5,2,16,5.4l-1.8,1.8c-0.2,0.2-0.4,0.2-0.6,0.2
                        h-5.7c-0.7,0-1.3,0.3-1.7,0.7l-1.7,1.7c-0.2,0.2-0.4,0.3-0.6,0.2c-1.5-0.1-5.3-0.1-6.9,2.6c-1,1.7-1.4,3.5-1.6,4.7
                        c-0.1,0.7,0.1,1.4,0.6,1.9c0.5,0.5,1.1,0.8,1.8,0.8H40c0.2,0,0.4,0.1,0.6,0.2l6.2,6.2c0.5,0.5,1.1,0.7,1.7,0.7h2.6
                        c0.6,0,1.1-0.2,1.6-0.6l0.7-0.6c0.1-0.1,0.3-0.2,0.5-0.2h1.2c0.3,0,0.5,0.1,0.7,0.4l1.8,2.6c0.5,0.7,1.2,1.1,2,1.1h2.5
                        c-1.2,14.2-12.8,25.3-26.9,25.3c-14.9,0-27-12.4-27-27.6c0-7.8,3.3-15.3,9-20.6c0.3-0.3,0.4-0.8,0.1-1.2c-0.3-0.3-0.8-0.4-1.1-0.1
                        c-4.7,4.3-7.8,10.1-9,16.3c-3.8-4-5.6-7.5-5.1-10.5c0.6-3.9,4.9-6.3,9-8.3c5.4-2.5,9-5.4,10.3-6.5c1.2,1.5,4,6.4,2.6,15.8
                        c-1.6,11.3-12.3,10.6-12.7,10.6c-0.4,0-0.8,0.3-0.9,0.7c0,0.5,0.3,0.8,0.7,0.9c0,0,0.2,0,0.6,0c2.5,0,12.2-0.7,13.9-12
                        c1.8-12.5-3.4-17.6-3.6-17.8L21.3,1l-0.5,0.5c0,0-3.9,3.7-10.5,6.8c-4.5,2.1-9.1,4.9-9.9,9.5c-0.6,3.8,1.5,7.9,6.4,12.8
                        c-0.1,1.1-0.2,2.3-0.2,3.5c0,16.1,12.9,29.3,28.7,29.3S63.8,50.2,63.8,34C63.8,17.9,50.9,4.7,35.1,4.7"
        />
        <path
          d="M36.4,39.7c-0.5-0.4-1.1-0.7-1.7-0.7h-2.8c-0.4,0-0.8-0.4-0.8-0.8v-1.9c0-0.2,0.1-0.4,0.2-0.6l3.1-3.2
                        c0.2-0.2,0.4-0.2,0.6-0.2h4.8c0.2,0,0.4,0.1,0.6,0.3l6.2,6.5c0.2,0.2,0.2,0.4,0.2,0.6v6.8c0,0.2-0.1,0.4-0.2,0.6L42.5,51
                        c-0.2,0.2-0.4,0.2-0.6,0.2h-2.1c-0.5,0-0.8-0.4-0.8-0.8v-7.1c0-0.7-0.3-1.3-0.7-1.8L36.4,39.7z M39.8,52.9H42
                        c0.6,0,1.3-0.3,1.7-0.7l4.1-4.2c0.5-0.5,0.7-1.1,0.7-1.7v-6.8c0-0.7-0.2-1.3-0.7-1.7l-6.2-6.5c-0.5-0.5-1.1-0.7-1.7-0.7H35
                        c-0.6,0-1.2,0.3-1.7,0.7l-3.1,3.2c-0.5,0.5-0.7,1.1-0.7,1.8v1.9c0,1.4,1.1,2.5,2.4,2.5h2.8c0.2,0,0.4,0.1,0.6,0.2l1.9,1.9
                        c0.2,0.2,0.2,0.4,0.2,0.6v7.1C37.4,51.8,38.5,52.9,39.8,52.9"
        />
      </svg>
    </svg>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconKlimaat extends Vue {}
</script>
